export const APP_DOMAIN = "sqit.bionivid.in";
export const MARKETING_DOMAIN = "bioinfo.bionivid.in";

export const isAppDomain =
  window.location.hostname === APP_DOMAIN;

export const isMarketingDomain =
  window.location.hostname === MARKETING_DOMAIN;